import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Skighnet · Amplify Gen 2</p>
        <h1>Welcome to DCP ReRoll</h1>
        <p className="lede">
          Your go-to source for the latest updates and insights on cannabis policy and culture in our area. 
          Explore comprehensive coverage of local laws, educational resources, and news on cannabis-related topics.
        </p>
        <div className="cta-row">
          <a href="https://docs.aws.amazon.com/amplify/latest/userguide/welcome.html" target="_blank">
            Amplify Docs
          </a>
          <a href="https://github.com/skighnet" target="_blank" className="secondary">
            Visit Skighnet
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Stay Informed</h2>
          <p>
            Get the latest updates on cannabis legislation and policy changes that affect our community.
          </p>
        </article>
        <article>
          <h2>Understand the Law</h2>
          <p>
            Access clear and concise information about the legal status of cannabis in our area, including 
            regulations and compliance guidelines.
          </p>
        </article>
        <article>
          <h2>Educational Resources</h2>
          <p>
            Discover a wealth of educational content designed to inform and empower you about cannabis culture 
            and its implications in society.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;